/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Category_GeneratedInputs */



/**
* | output |
* | --- |
* | "Generated" |
*
* @param {Voice_Manager_Elevenlabs_Category_GeneratedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_category_generated = /** @type {((inputs?: Voice_Manager_Elevenlabs_Category_GeneratedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Category_GeneratedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Générée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Generiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сгенерированный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("生成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("生成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जनरेट की गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerada")
	return /** @type {LocalizedString} */ ("Generated")
});